import React from 'react';

function PlusPrimary(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='18'
      height='18'
      fill='none'
      viewBox='0 0 18 18'
      {...props}
    >
      <path
        fill='#E00034'
        fillRule='evenodd'
        d='M7.806 1.115a1.115 1.115 0 112.23 0v6.69h6.849a1.115 1.115 0 110 2.23h-6.85v6.85a1.115 1.115 0 11-2.23 0v-6.85h-6.69a1.115 1.115 0 110-2.23h6.69v-6.69z'
        clipRule='evenodd'
      ></path>
    </svg>
  );
}

export default PlusPrimary;
